import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { applySeo } from '../utils/seo'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Cashless FYI | Free Cashless Program ROI Calculators',
      description:
        'Free, vendor-neutral ROI calculators for cashless programs in healthcare, senior living, and corporate dining. Model payroll deduction, participation, and payback before you talk to vendors.',
    },
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: {
      title: 'About Cashless FYI | Vendor-Neutral Cashless Education',
      description:
        'Cashless FYI is an educational front door for cashless programs in healthcare, senior living, and corporate dining, provided by Newcare and kept separate from the sales pitch.',
    },
  },
  {
    path: '/calculators',
    name: 'calculators',
    component: () => import(/* webpackChunkName: "calculators" */ '../views/Calculators.vue'),
    meta: {
      title: 'ROI Calculators | Cashless FYI',
      description:
        'Choose a free cashless ROI calculator: payroll deduction for healthcare, corporate dining, or participation levers for Prime Cost and multi-year profitability.',
    },
  },
  {
    path: '/calculators/payroll-deduction',
    name: 'calculator-payroll-deduction',
    component: () => import(/* webpackChunkName: "calc-payroll" */ '../views/PayrollDeductionROI.vue'),
    meta: {
      title: 'Payroll Deduction ROI Calculator (Healthcare) | Cashless FYI',
      description:
        'Free calculator to estimate payroll deduction ROI for healthcare and senior living: ticket lift, participation, traffic impact, payback period, and annual profit.',
    },
  },
  {
    path: '/calculators/participation',
    name: 'calculator-participation',
    component: () => import(/* webpackChunkName: "calc-participation" */ '../views/ParticipationROI.vue'),
    meta: {
      title: 'Participation ROI Calculator | Cashless FYI',
      description:
        'Free calculator comparing participation, transaction boost, and labor refinement against Prime Cost and profitability over 1, 3, and 5 years.',
    },
  },
  {
    path: '/calculators/corporate-dining',
    name: 'calculator-corporate-dining',
    component: () => import(/* webpackChunkName: "calc-corporate" */ '../views/CorporateDiningROI.vue'),
    meta: {
      title: 'Corporate Dining ROI Calculator | Cashless FYI',
      description:
        'Free calculator for cashless programs in corporate dining—participation, retention, menu data, and competition with off-site dining.',
    },
  },
  {
    path: '/tou',
    name: 'TOU',
    component: () => import(/* webpackChunkName: "tos" */ '../views/TOU.vue'),
    meta: {
      title: 'Terms of Use | Cashless FYI',
      description: 'Terms of use for Cashless FYI ROI calculators and related educational content.',
    },
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import(/* webpackChunkName: "privacy" */ '../views/Privacy.vue'),
    meta: {
      title: 'Privacy Policy | Cashless FYI',
      description: 'How Cashless FYI handles contact information and calculator worksheet data from PDF report downloads.',
    },
  },
  {
    path: '/donations',
    name: 'donations',
    component: () => import(/* webpackChunkName: "dontations" */ '../views/Donations.vue'),
    meta: {
      title: 'Donations | Cashless FYI',
      description: 'Support Cashless FYI.',
      robots: 'noindex',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash, behavior: 'smooth' }
    }
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
})

router.afterEach((to) => {
  const { title, description, robots } = to.meta || {}
  applySeo({
    title,
    description,
    path: to.path,
    robots,
  })
})

export default router
